import { ref, computed } from 'vue'

export function useScanHistory(storageKey) {
  const allHistory = ref({})
  const selectedDate = ref('')

  const load = () => {
    try {
      const raw = localStorage.getItem(storageKey)
      allHistory.value = raw ? JSON.parse(raw) : {}
    } catch {
      allHistory.value = {}
    }
    cleanup()
    const dates = availableDates.value
    if (dates.length > 0 && !dates.includes(selectedDate.value)) {
      selectedDate.value = dates[0]
    }
  }

  const save = () => {
    localStorage.setItem(storageKey, JSON.stringify(allHistory.value))
  }

  const cleanup = () => {
    let total = 0
    const dates = Object.keys(allHistory.value).sort().reverse()
    let changed = false
    for (const date of dates) {
      const entries = allHistory.value[date]
      if (total + entries.length <= 1000) {
        total += entries.length
      } else {
        const remaining = 1000 - total
        if (remaining > 0) {
          allHistory.value[date] = entries.slice(0, remaining)
          total = 1000
        } else {
          delete allHistory.value[date]
        }
        changed = true
      }
    }
    if (changed) save()
  }

  const formatDate = (d) => {
    const y = d.getFullYear()
    const m = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    return `${y}-${m}-${day}`
  }

  const addEntry = (matchKey, result) => {
    const now = new Date()
    const date = formatDate(now)
    const time = now.toLocaleTimeString('ja-JP', { hour: '2-digit', minute: '2-digit', second: '2-digit' })

    if (!allHistory.value[date]) {
      allHistory.value[date] = []
    }
    allHistory.value[date].unshift({ date, time, matchKey: matchKey || '', result })
    selectedDate.value = date
    cleanup()
    save()
  }

  const availableDates = computed(() => {
    return Object.keys(allHistory.value).sort().reverse()
  })

  const currentEntries = computed(() => {
    return allHistory.value[selectedDate.value] || []
  })

  load()

  return {
    selectedDate,
    availableDates,
    currentEntries,
    addEntry,
    load
  }
}
